import { IFindProfileResponse } from '@/api/ProfileApi'

export enum AddressType {
  HOME = 'Home',
  WORK = 'Work',
  ETC = 'Etc.',
}

export const addressTypeCode = {
  [AddressType.HOME]: 'H',
  [AddressType.WORK]: 'W',
  [AddressType.ETC]: 'O',
}

export interface IAddress {
  provinceCode: string // province code
  provinceName: string // province 명
  cityCode: string // city (DATI II) code
  cityName: string // city (DATI II) 명
  districtCode: string // district (town, kecamatan) code
  districtName: string // district (town, kecamatan) 명
  subDistrictCode: string // sub district (village, kelurahan) code
  subDistrictName: string // sub district (village, kelurahan) 명
  zipCode: string // 우편번호
  detailAddress: string // 상세주소
  rt?: string
  rw?: string
  detailLocation?: string
  isDisabledShipping?: boolean
}

export const EmptyAddress = {
  provinceCode: '',
  provinceName: '',
  cityCode: '',
  cityName: '',
  districtCode: '',
  districtName: '',
  subDistrictCode: '',
  subDistrictName: '',
  zipCode: '',
  detailAddress: '',
  detailLocation: '',
}

export interface IUserProfile extends IFindProfileResponse {}
